import { Container, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";

import { useTranslation } from "@/lib/i18n";
import OrganisationsDetailCards from "@/features/admin/features/organisations/components/organisations-detail-card";
import { useOrganisationQuery } from "@/features/admin/features/organisations/hooks/queries";
import BreadCrumbs from "@/features/admin/features/organisations/components/breadcrumbs";
import UserTable from "@/features/admin/features/users/components/user-table";

const OrganisationDetailPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const splitLocation = location.pathname.split("/");
  const organisationId = splitLocation[splitLocation.length - 1];
  const organisationData = useOrganisationQuery(organisationId);

  if (!organisationData.data) return null;

  const { name, accessible_dashboards } = organisationData.data;

  return (
    <Container sx={{ mt: { xs: 2, md: 6 } }}>
      <Grid container spacing={10}>
        <Grid item xs={12}>
          <BreadCrumbs
            paths={[
              { label: t("admin.organisations.plural"), value: "organisations" },
              { label: name, value: name },
            ]}
          />
          <h1 style={{ marginBottom: 0 }}>Dashboards {name}</h1>
          <p style={{ marginTop: "8px" }}>
            Alle gebruikers krijgen bij een uitnodiging toegang tot deze dashboards
          </p>

          {accessible_dashboards ? (
            <OrganisationsDetailCards dashboards={accessible_dashboards} />
          ) : null}
        </Grid>

        <Grid item xs={12}>
          <UserTable organisation={organisationData.data} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default OrganisationDetailPage;
